import React, { useCallback } from 'react';
import { createEventChannelBridgeFactory } from '../bridge-utils';
import { createEventChannel } from '../core';

// TODO: Would be better if there were separate event channels for each type of metal metric
/**
 * @deprecated
 */
export var createMetalEventChannel = createEventChannel;
/**
 * @deprecated
 */
export var createMetalEventChannelBridge = createEventChannelBridgeFactory(createMetalEventChannel, function (client, payload) {
  return client.metric.submit(payload);
});
export var MetalIntegration = function MetalIntegration(_ref) {
  var Listener = _ref.Listener,
    client = _ref.client,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Listener, {
    onEvent: useCallback(function (metalPayload) {
      client.metric.submit(metalPayload);
    }, [client])
  }, children);
};